import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    styleContainer: {
        width: 'auto',
        background: 'white',
        borderRadius: 8,
        padding: '16px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    styleHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: 10,
        width: '100%',
        position: 'relative',
    },
    borderBottom: {
        borderBottom: '1px solid #d1d1d1',
    },
    user: {
        display: 'flex',
        width: '100%',
    },
    titleDetail: {
        margin: 0,
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        fontSize: 14,
        color: themes.palette.primary.main,
        whiteSpace: 'nowrap',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    userName: {
        opacity: 0.5,
        wordWrap: 'break-word',
    },
    avatar: {
        minWidth: 40,
    },
    avatarImage: {
        width: 40,
        height: 'auto',
        borderRadius: '50%',
    },
    title: {
        paddingLeft: 8,
    },
    priceWrapper: {
        width: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: 30,
    },
    price: {
        padding: 10,
        background: themes.palette.primary.light,
        borderRadius: 10,
        fontFamily: 'PoppinsRegular',
        fontWeight: 600,
        fontSize: 14,
        color: themes.palette.primary.main,
    },
    brandName: {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2,
    },
    styleContent: {
        position: 'relative',
        height: 'auto',
    },
    itemImage: {
        width: 'auto',
        height: '100%',
        objectFit: 'scale-down',
        margin: 'auto',
        maxWidth: '100%',
    },
    actions: {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',

        flexDirection: 'column',
        top: '50%',
        transform: 'translateY(-50%)',
        right: 0,
        width: 'auto',
        zIndex: 2,
        padding: '5px 0',
    },
    actionsIcon: {
        marginTop: 6,
        padding: 0,
        width: 42,
        height: 42,
        borderRadius: '50%',
        backgroundColor: themes.palette.primary.light,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    actionsIconV2: {
        margin: '12px 0',
        padding: 0,
        width: 'calc(50% - 6px)',
        height: 42,
        borderRadius: 29,
        backgroundColor: themes.palette.primary.light,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    headerActionContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        right: 0,
    },
    headerActionIcon: {
        width: 24,
        height: 24,
        marginLeft: 12,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    marginTop16: {
        marginTop: 16,
    },
    disabled: {
        pointerEvents: 'none',
        filter: 'none',
    },
    // actionsContainer:{
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     flexDirection:'column'
    // },
    actionStylist: {
        // padding: 10,
        width: 45,
        height: 45,
        // marginBottom: 5,
        // borderRadius: '50%',
        // backgroundColor: '#e8f0f1',
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // '&:nth-child(3)':{
        //     marginBottom : 20
        // }
    },
    actionStatistic: {
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'PoppinsRegular',
        color: themes.palette.primary.main,
        lineHeight: 1,
        paddingTop: '3px',
    },
    styleAction: {
        marginTop: 'auto',
    },
    buttonAddtoBag: {
        width: '100%',
        height: 48,
        padding: '5px 0',
        color: '#fff',
        fontSize: 14,
        fontWeight: 400,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        border: 'none',
        borderRadius: 29,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonConsult: {
        width: '100%',
        height: 48,
        padding: '5px 0',
        color: themes.palette.primary.main,
        marginTop: 5,
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'PoppinsRegular',
        background: '#fff',
        border: '1px solid ',
        borderRadius: 29,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
    },
    multiple: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        justifyContent: 'flex-end',
    },
    multipleItem: {
        padding: '5px 0',
        cursor: 'pointer',
    },
    editOrAddButton: {
        width: '100%',
        height: '48px',
        padding: '15px 0',
        color: 'white',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        border: 'none',
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:disabled': {
            opacity: 0.5,
        },
    },
    sortWrap: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
    },
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    input: {
        padding: '0px',
        width: '100%',
        paddingLeft: '14px',
        background: 'transparent',
        border: 'none',
        borderBottom: 'none !important',
        color: themes.palette.primary.main,
        fontSize: '16px',
        borderRadius: 0,
        outline: 'none !important',
    },
    label: {
        fontSize: '14px',
    },
    searchBox: {
        marginTop: 22,
        borderBottom: '1px solid #BBC8CA',
        paddingBottom: 10,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        marginBottom: '16px',
    },
    buttonPublishBox: {
        position: 'fixed',
        '@media (min-width: 1024px)': {
            position: 'absolute',
        },
        width: 'auto',
        left: 0,
        right: 0,
        zIndex: 100,
        bottom: 0,
        padding: 24,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
    buttonPublish: {
        width: '100%',
        height: '48px',
        padding: '0',
        textAlign: 'center',
        color: '#1D474F',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'Graphik',
        background: '#FFFFFF',
        border: '1px solid #4A6C72',
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:disabled': {
            backgroundColor: '#b5b5b5',
        },
    },
    suggestions: {
        display: 'flex',
        position: 'absolute',
        backgroundColor: 'white',
        zIndex: 100000,
        overflowY: 'auto',
        top: '48px',
        left: '0',
        right: '0',
        borderRadius: '8px',
        height: '100%',
        maxHeight: `350px`,
    },
    suggestionItem: {
        display: 'flex',
        paddingBottom: 12,
        cursor: 'pointer',
    },
    suggestionAvatar: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
    },
    suggestionTitle: {
        color: '#000000',
        fontSize: 14,
        flex: 1,
        paddingLeft: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    noSuggestions: {
        color: '#000000',
        width: '100%',
        textAlign: 'center',
    },
    selectedOptions: {
        overflowY: 'scroll',
        maxHeight: '100%',
        position: 'absolute',
        left: 18,
        right: 18,
        top: '135px',
        bottom: '0px',
        paddingBottom: 150,
        scrollBehavior: 'smooth',
    },
    feedbackContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginBottom: '14px',
        backgroundColor: 'white',
        padding: '12px',
        borderRadius: '8px',
    },
    feedbackUserName: {
        color: '#000',
        fontSize: 12,
        fontFamily: 'PoppinsRegular',
        flex: 1,
        paddingLeft: 8,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    feedbackUser: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: 10,
    },
    feedbackList: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        margin: '6px 2px',
    },
    feedbackItem: {
        backgroundColor: '#F2D4BD',
        borderRadius: 20,
        padding: '6px 10px',
        fontSize: 14,
        margin: 5,
        fontFamily: 'Poppins',
    },
    feedbackUserContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    feedbackCreated: {
        margin: 0,
        color: '#000',
        fontSize: 12,
        fontFamily: 'PoppinsRegular',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    categoryName: {
        fontFamily: 'PoppinsMedium',
        fontSize: '16px',
        marginBottom: '8px',
    },
    listOptions: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    category: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '18px',
        paddingBottom: '18px',
        '&:not(:last-child)': {
            borderBottom: '1px solid #D1D1D1',
        },
    },
}));
